import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

/**
 * Smarter Placeholder
 * - on focus remove placeholder text and return on blur
 */
@Directive({
    selector: 'input[placeholder], textarea[placeholder]',
})
export class PlaceholderDirective {

    private _placeholder = '';

    @Input()
    set placeholder(value: string) {
        this._placeholder = value;
        this.update(value);
    }

    constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

    private update(placeholder: string) {
        this.renderer.setAttribute(this.elementRef.nativeElement, 'placeholder', placeholder);
    }

    @HostListener('focus')
    onFocus() {
        this.update('');
    }

    @HostListener('blur')
    onBlur() {
        this.update(this._placeholder);
    }
}
